



















































































import { Vue, Component, Prop, Watch, Emit } from 'vue-property-decorator'
import { EPLModule } from '@/store/eplmodule'
import moment from 'moment'

@Component({ name: 'DateTimePicker' })
export default class DateTimePicker extends Vue {
  @Prop() unixtime!: number
  @Prop() label!: string
  @Prop() len!: string
  @Prop() disabled!: boolean
  @Prop() signed!: boolean
  @Prop() readonly!: boolean
  @Prop() dateonly!: boolean

  menu1 = false
  menu2 = false
  time = '00:00'
  date = ''
  tzoffset = 0
  idx = -1

  get arrivedfacttime () {
    if (EPLModule.dicts[this.idx] === undefined) return 0
    return EPLModule.dicts[this.idx].currentRow.arrivedfacttime
  }

  @Watch('arrivedfacttime')
  onArrivedFChange () {
    if (this.len === 'arrivedfacttime') {
      this.calcExpDate()
    }
  }

  get arrivedplanetime () {
    if (EPLModule.dicts[this.idx] === undefined) return 0
    return EPLModule.dicts[this.idx].currentRow.arrivedplanetime
  }

  @Watch('arrivedplanetime')
  onArrivedPChange () {
    if (this.len === 'arrivedfacttime') {
      this.calcExpDate()
    }
  }

  calcExpDate () {
    const date0 = EPLModule.dicts[this.idx].currentRow.expdate
    const date1 = EPLModule.dicts[this.idx].currentRow.arrivedplanetime
    const date2 = EPLModule.dicts[this.idx].currentRow.arrivedfacttime
    if (date0 < date1 || date0 < date2) {
      if (date2 < date1) {
        this.date = new Date(date1 * 1000 - this.tzoffset)
          .toISOString()
          .substr(0, 10)
      } else {
        this.date = new Date(date2 * 1000 - this.tzoffset)
          .toISOString()
          .substr(0, 10)
      }
      this.updateDateTime()
    } else {
      this.date = new Date(date0 * 1000 - this.tzoffset)
        .toISOString()
        .substr(0, 10)
    }
  }

  @Watch('unixtime')
  onUnixtimeChange () {
    if (this.unixtime === undefined) return
    if (this.unixtime === 0) {
      this.date = new Date(Date.now() - this.tzoffset)
        .toISOString()
        .substr(0, 10)
      this.time = new Date(Date.now() - this.tzoffset)
        .toISOString()
        .substr(11, 5)
    } else {
      if (this.len === 'arrivedfacttime') {
        this.calcExpDate()
      } else {
        this.date = new Date(this.unixtime * 1000 - this.tzoffset)
          .toISOString()
          .substr(0, 10)
        this.time = new Date(this.unixtime * 1000 - this.tzoffset)
          .toISOString()
          .substr(11, 5)
      }
    }
  }

  @Emit('update:unixtime')
  update (val: number) {
    return val
  }

  mounted () {
    this.tzoffset = new Date().getTimezoneOffset() * 60000
    // this.updateDateTime()
    this.idx = EPLModule.DictIdx('EPL')
    this.onUnixtimeChange()
  }

  get dateFormatted () {
    return moment.unix(this.getUnixTime).format('DD.MM.YYYY')
  }

  get getUnixTime () {
    return parseInt(
      (new Date(`${this.date} ${this.time}`).getTime() / 1000).toFixed(0)
    )
  }

  private updateDateTime () {
    let tmp = this.getUnixTime
    if (this.dateonly) {
      if (this.len === 'arrivedfacttime') {
        tmp = parseInt((new Date(`${this.date} 23:59:59`).getTime() / 1000).toFixed(0))
      }
    }
    this.update(tmp)
  }
}
